

const slugs = {
    // private
    dashboard: '/dashboard',
    agents: '/agents',
    credit: '/credit',
    products: '/products',
    productsTwo: '/products/two',
    productsThree: '/products/three',
    transactions: '/transactions',
    scratchCards: '/scratchCards',
    scratchCardsTwo: '/addCards/',
    packages: '/packages',
    contacts: '/contacts',
    addpackage: '/addpackage',
    analytics: '/analytics',
    payoutCash: '/payoutcash',
    individualSavingStatement: '/individualSavingStatement',
    farmer: '/farmer',
    login: '/login',
    signup: '/signup',
    forgotPassword: '/forgot_password',
    bulkSms: '/sms'
};

export default slugs;
